export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotVideosSection />
        <LatestVideosSection />
        <TrendingSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}

import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import PageSEO from '@/components/base/PageSEO';
import VideoCard from '@/components/feature/VideoCard';
import { Link } from 'react-router-dom';
import { categories, videos, trendingTags } from '@/mocks/videos';
import { useState, useMemo } from 'react';

function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': '黑料视频 - 明星艺人黑料视频大全',
    'description': '黑料视频收录娱乐圈最新最全明星黑料视频，涵盖艺人丑闻、翻车现场、争议事件等真实影像记录。',
    'url': 'https://heiliaoshipin.com/',
    'isPartOf': {
      '@type': 'WebSite',
      'name': '黑料视频',
      'url': 'https://heiliaoshipin.com',
    },
    'breadcrumb': {
      '@type': 'BreadcrumbList',
      'itemListElement': [{
        '@type': 'ListItem',
        'position': 1,
        'name': '首页',
        'item': 'https://heiliaoshipin.com/',
      }],
    },
  };

  return (
    <>
      <PageSEO jsonLd={homeJsonLd} />
      <section className="relative pt-16">
        <div className="relative h-[420px] md:h-[540px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20entertainment%20newsroom%20background%20with%20dramatic%20red%20accents%2C%20multiple%20floating%20screens%20showing%20blurred%20celebrity%20footage%2C%20film%20noir%20atmosphere%2C%20deep%20shadows%2C%20moody%20dark%20tones%2C%20abstract%20geometric%20patterns%2C%20modern%20media%20aesthetic%2C%20professional%20broadcast%20vibe&width=1800&height=800&seq=hero-bg-01&orientation=landscape"
            alt="黑料视频 - 明星艺人黑料视频大全"
            title="黑料视频主页背景"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50"></div>

          <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
            <div className="w-full max-w-3xl text-center">
              <h1 className="font-heading text-2xl md:text-5xl text-foreground-50 mb-4 leading-tight">
                娱乐圈<strong className="text-primary-500">黑料视频</strong>大全
              </h1>
              <p className="text-sm md:text-base text-foreground-300 mb-8 max-w-2xl mx-auto leading-relaxed">
                收录最新最全明星艺人黑料视频，涵盖丑闻曝光、翻车现场、争议事件等真实影像记录，持续更新热门内容
              </p>

              <div className="relative max-w-xl mx-auto">
                <div className="flex items-center bg-background-100/80 backdrop-blur-md border border-background-300/60 rounded-full overflow-hidden">
                  <div className="pl-5 w-5 h-5 flex items-center justify-center">
                    <i className="ri-search-line text-foreground-500 text-sm"></i>
                  </div>
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="搜索明星黑料视频..."
                    className="flex-1 bg-transparent text-sm text-foreground-100 placeholder-foreground-600 py-3.5 px-3 outline-none"
                  />
                  <button className="px-6 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer rounded-r-full">
                    搜索
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-center flex-wrap gap-2 mt-6">
                {trendingTags.slice(0, 6).map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full text-xs bg-background-200/70 text-foreground-400 border border-background-300/60 hover:text-primary-400 hover:border-primary-500/30 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

function CategoryNav() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading text-lg md:text-xl text-foreground-100">
          视频分类
        </h2>
        <Link
          to="/"
          className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group bg-background-100 border border-background-300/60 rounded-lg p-4 md:p-5 hover:border-primary-500/30 transition-all duration-300 hover:translate-y-[-2px]"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
              <i className={`${cat.icon} text-lg md:text-xl`}></i>
            </div>
            <h3 className="text-sm font-medium text-foreground-200 group-hover:text-foreground-50 transition-colors duration-200 whitespace-nowrap">
              {cat.name}
            </h3>
            <p className="text-xs text-foreground-600 mt-1 whitespace-nowrap">{cat.count} 个视频</p>
          </Link>
        ))}
      </div>
    </section>
  );
}

function HotVideosSection() {
  const hotVideos = useMemo(() => videos.filter((v) => v.isHot), []);

  return (
    <section className="bg-background-100 border-y border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-fire-line text-xl text-primary-500"></i>
            </div>
            <h2 className="font-heading text-lg md:text-xl text-foreground-100">
              热门黑料
            </h2>
          </div>
          <Link
            to="/category/mingxing-heiliao"
            className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
          >
            更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotVideos.slice(0, 6).map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}

function LatestVideosSection() {
  const latestVideos = useMemo(
    () => [...videos].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()),
    [],
  );

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-time-line text-xl text-accent-500"></i>
          </div>
          <h2 className="font-heading text-lg md:text-xl text-foreground-100">
            最新更新
          </h2>
        </div>
        <Link
          to="/category/zuixin-baoliao"
          className="text-xs text-foreground-500 hover:text-primary-400 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
        >
          更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {latestVideos.slice(0, 8).map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}

function TrendingSection() {
  const hotList = useMemo(
    () => [...videos].sort((a, b) => b.views - a.views).slice(0, 8),
    [],
  );

  return (
    <section className="bg-background-100 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-bar-chart-2-line text-xl text-accent-500"></i>
          </div>
          <h2 className="font-heading text-lg md:text-xl text-foreground-100">
            热搜榜单
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {hotList.map((video, index) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group flex items-start gap-4 bg-background-50 border border-background-300/60 rounded-lg p-4 hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <span className={`font-heading text-lg ${
                  index < 3 ? 'text-primary-500' : 'text-foreground-500'
                }`}>
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-200 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2 leading-snug mb-1">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-600">
                  <span className="px-2 py-0.5 rounded bg-secondary-100/80 text-secondary-900 whitespace-nowrap text-[11px]">
                    {video.category}
                  </span>
                  <span className="whitespace-nowrap">{video.publishDate}</span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {(video.views / 10000).toFixed(1)}万
                  </span>
                </div>
              </div>
              <div className="w-24 h-16 flex-shrink-0 rounded-md overflow-hidden hidden sm:block">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}